<template>
  <div class="dsf-question-upLoadimg">
    <ul class="el-upload-list el-upload-list--picture-card" v-if="fileListCopy.length > 0">
      <li tabindex="0" class="el-upload-list__item is-success" v-for="item in fileListCopy" :key="item.id">
        <div>
          <el-image
            ref="elImage"
            style="height: 50px; width: 50px"
            :src="item.relativePath"
            :alt="item.name"
            :preview-src-list="[item.relativePath]"
            fit="cover"
            :z-index="99999"
          >
          </el-image>
          <span class="el-upload-list__item-actions" v-if="!readOnly">
            <!-- <span
              @click="handleDownload(item)"
              class="el-upload-list__item-delete"
            >
              <i class="el-icon-download"></i>
            </span> -->
            <span @click="handleRemove(item)" class="el-upload-list__item-delete">
              <i class="el-icon-error"></i>
            </span>
          </span>
        </div>
      </li>
    </ul>
    <el-upload
      v-if="!readOnly"
      style="display: inline"
      ref="uploadPhotos"
      :action="dsf.url.getWebPath('/file/upload')"
      :on-error="handleAvatarError"
      :on-success="handleAvatarSuccess"
      :show-file-list="false"
      :on-change="handleChange"
      :on-exceed="handleExceed"
      :before-upload="beforeAvatarUpload"
      list-type="picture-card"
      :auto-upload="true"
      :multiple="multiple"
      :limit="limitNum"
    >
      <i slot="default" class="iconfont icon-add"></i>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: "DsfQuestionUpLoadImg",
  props: {
    optionsId: { type: Number, default: -1 },
    fileList: {
      type: String,
      default: "[]",
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    //是否支持多选文件
    multiple: {
      type: Boolean,
      default: true,
    },
    //最大允许上传个数
    limitNum: {
      type: Number,
      default: 2,
    },
    //最大允许上传大小 单位M
    maxSize: {
      type: Number,
      default: 2,
    },
    //允许上传文件类型
    uploadFileExts: {
      type: String,
      default: "bpm,jpg,jpeg,png,gif",
    },
  },
  data() {
    return {
      fileListCopy: [], //图片上传
      // optionDisabled: false, //是否禁用图片的功能
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.fileListCopy = JSON.parse(!this.fileList ? "[]" : this.fileList);
    });
  },
  destroyed() {
    // console.log(this.optionsId);
  },
  methods: {
    handleAvatarSuccess(res, file) {
      this.fileListCopy.push(file.response.data[0]);
      this.imageUrl = URL.createObjectURL(file.raw);
      this.$emit("get-imglist", this.fileListCopy, this.optionsId);
    },

    handleAvatarError(res, file) {
      // this.imageUrl = URL.createObjectURL(file.raw);
      if (res) {
        dsf.layer.message("图片上传失败", false);
      }
    },
    handleDownload(file) {
      let url = dsf.url.getWebPath("/file/download");
      $(
        '<form action="' +
          url +
          '" method="get">' + // action请求路径及推送方法
          '<input type="text" name="files" value="' +
          file.id +
          '"/>' + // id^fileName
          '<input type="text" name="zipName" value="' +
          (file.originalFileName || "") +
          '"/>' + // 压缩包名称
          "</form>"
      )
        .appendTo("body")
        .submit()
        .remove();
    },
    beforeAvatarUpload(file) {
      const isJPG = this.uploadFileExts.includes(file.type.split("/")[1]);
      const isLt5M = file.size / 1024 / 1024 < this.maxSize;
      if (!isJPG || isJPG < 0) {
        // dsf.layer.message('上传的图片只能是 ' + this.uploadFileExts + '格式!', false);
        dsf.layer.message(`上传的不是图片文件,请选择包含这些格式的文件：${this.uploadFileExts}`, false);
        return false;
      }
      if (!isLt5M) {
        dsf.layer.message("上传的图片大小不能超过 " + this.maxSize + "MB!", false);
        return false;
      }
      // 是否有重名
      let hasSameName = false,
        repeateName = "";
      // 上传的文件与已上传的文件名对比
      _.forEach(this.fileListCopy, (item) => {
        if (item.originalFileName == file.name) {
          hasSameName = true;
          repeateName += item.originalFileName + " ";
        }
      });
      if (hasSameName) {
        dsf.layer.message(`已存在文件【${repeateName}】，请修改后重新上传`, false);
        return false;
      }
      // var limit = this.fileListCopy.length < this.limitNum;
      if (this.fileListCopy.length >= this.limitNum) {
        dsf.layer.message(`当前限制选择最多 ${this.limitNum} 张图片`, false);
        return false;
      }
      // return isJPG && isLt5M && !hasSameName && limit;
    },

    handleExceed(files, fileListCopy) {
      dsf.layer.message(`当前限制选择最多 ${this.limitNum} 张图片`, false);
    },

    handleChange(files, fileListCopy) {
      //handleChange在 事件beforeAvatarUpload 之前触发
      // this.fileListCopy = fileListCopy;
    },

    handleRemove(file) {
      _.forEach(this.$refs.uploadPhotos.uploadFiles, (item, index) => {
        if (item?.name == file?.originalFileName) {
          this.$refs.uploadPhotos.uploadFiles.splice(index, 1);
        }
      });
      _.forEach(this.fileListCopy, (item, index) => {
        if (item?.originalFileName == file?.originalFileName) {
          this.fileListCopy.splice(index, 1);
        }
      });
      this.$emit("get-imglist", this.fileListCopy, this.optionsId);
    },
  },
};
</script>

<style></style>
